<p-tabView styleClass="chat-list-tabs p-tabview-panels-no-padding p-tabview-nav-container-no-padding">
  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="pi pi-comments"></i>
      <span class="ml-1">APP Operarios</span>
      <span class="bullet" *ngIf="unreadChats.length > 0">{{unreadChats.length}}</span>
    </ng-template>

    <h4 class="ml-4 mr-4" *ngIf="unreadChats.length > 0">{{unreadChats.length}} chats sin leer</h4>
    <div *ngFor="let chat of unreadChats" class="sidebar-item" (click)="goTo(chat)">
      <p-card styleClass="p-card-no-padding">
        <div class="p-2 flex align-items-center gap-2">
          <div style="position: relative;">
            <i class="pi pi-comment" style="font-size: 25px;"></i>
            <span class="bullet">&nbsp;</span>
          </div>
          <div class="col">
            {{chat.title}}
            <div *ngIf="chat.caseId">
              <small>
                <a [routerLink]="['/cases', chat.case?.id]" target="_blank" (click)="$event.stopPropagation()">{{chat.case?.caseNumber}}</a> -
                <label *ngIf="chat.case?.processorId!=user?.id" [ngClass]="chat.case.processor?.absence ? 'text-danger' : ''">{{chat.case?.processor?.name}}</label>
              </small>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <h4 class="mt-4 ml-4 mr-4" *ngIf="chats.length > 0">{{chats.length}} chats en los últimos 7 días</h4>
    <div *ngFor="let chat of chats" class="sidebar-item" (click)="goTo(chat)">
      <p-card styleClass="p-card-no-padding">
        <div class="p-2 flex align-items-center gap-2">
          <div style="position: relative;">
            <i class="pi pi-comment" style="font-size: 25px;"></i>
          </div>
          <div class="col">
            {{chat.title}}
            <div *ngIf="chat.caseId">
              <small>
                <a [routerLink]="['/cases', chat.case.id]" target="_blank" (click)="$event.stopPropagation()">{{chat.case?.caseNumber}}</a>
                <label *ngIf="chat.case?.processorId!=user?.id" [ngClass]="chat.case.processor?.absence ? 'text-danger' : ''"> - {{chat.case?.processor?.name}}</label>
              </small>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div *ngIf="unreadChats.length == 0 && chats.length == 0" class="m-4">
      No hay chats pendientes
    </div>
  </p-tabPanel>

  <p-tabPanel>
    <ng-template pTemplate="header">
      <i class="pi pi-whatsapp"></i>
      <span class="ml-1">Whatsapp</span>
      <span class="bullet" *ngIf="unreadWhatsapp.length > 0">{{unreadWhatsapp.length}}</span>
    </ng-template>

    <h4 class="ml-4 mr-4" *ngIf="unreadWhatsapp.length > 0">{{unreadWhatsapp.length}} whatsapp sin leer</h4>
    <div *ngFor="let message of unreadWhatsapp" class="sidebar-item" (click)="goToWhatsapp(message)">
      <p-card styleClass="p-card-no-padding">
        <div class="p-2 flex align-items-center gap-2">
          <div style="position: relative;">
            <i class="pi pi-whatsapp" style="font-size: 25px;"></i>
            <span class="bullet">&nbsp;</span>
          </div>
          <div class="col">
            {{message.clientName || message.phoneNumber}}
            <div>
              <small style="text-overflow: ellipsis; white-space: nowrap; overflow: hidden; display: block; max-width: 250px;">{{message.content}}</small>
            </div>
            <div>
              <small>
                <a *ngIf="message.caseId" [routerLink]="['/cases', message.caseId]">{{message.caseNumber}}</a>
                <label *ngIf="!message.caseId" class="text-danger">Sin expediente</label>
                 - {{message.createdAt | date:'dd/MM/yyyy HH:mm'}}
              </small>
            </div>
          </div>
        </div>
      </p-card>
    </div>

    <div *ngIf="unreadWhatsapp.length == 0" class="m-4">
      No hay whatsapp pendientes de leer
    </div>
  </p-tabPanel>
</p-tabView>
